import React from 'react';

/**
 * VIP All Access Badge Icon
 * Custom icon representing an all-access pass with VIP styling
 * Based on ID badge design with lanyard
 */
const VIPAllAccessIcon = ({ size = 24, className = '', color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Lanyard straps */}
      <line x1="8" y1="2" x2="10" y2="6" />
      <line x1="16" y1="2" x2="14" y2="6" />
      
      {/* Badge outline with rounded corners */}
      <rect x="6" y="6" width="12" height="16" rx="2" ry="2" />
      
      {/* Profile picture circle */}
      <circle cx="12" cy="11" r="2.5" />
      
      {/* User shoulders/body shape inside profile circle */}
      <path d="M 9.5 13 Q 12 14.5 14.5 13" fill="none" />
      
      {/* Information lines (name/details) */}
      <line x1="8" y1="17" x2="16" y2="17" />
      <line x1="9" y1="19" x2="15" y2="19" />
      
      {/* Optional: Edge detail for depth */}
      <line x1="18" y1="7" x2="18" y2="21" opacity="0.3" />
    </svg>
  );
};

export default VIPAllAccessIcon;
